export const PLATFORM_RECORD_EN = {
    'change.field.platform_user.email': 'Email',
    'change.field.platform_user.name': 'Name',
    'change.field.platform_user.password_hash': 'Password',
    'change.field.platform_user.must_change_password': 'Must choose a new password',
    'change.field.platform_user.role': 'Platform role',
    'change.field.platform_user.status': 'Status',
    'change.field.platform_user.second_factor_sealed': 'Authenticator',
    'change.field.platform_user.second_factor_confirmed_at': 'Two-step sign-in set up on',
    'change.field.platform_user.second_factor_pending_sealed': 'Authenticator awaiting its first code',
    'change.field.platform_user.recovery_code_hashes': 'Recovery codes',
    'change.field.platform_user.locked_until': 'Locked until',
    'change.field.platform_user.created_by': 'Added by',
    'change.field.platform_user.withdrawn_at': 'Withdrawn on',
    'change.field.platform_user.withdrawn_by': 'Withdrawn by',
    'change.field.platform_secret.name': 'Setting',
    'change.field.platform_secret.sealed_value': 'Value',
    'change.field.platform_secret.last4': 'Last four characters',
    'change.field.platform_secret.fingerprint': 'Fingerprint',
    'change.field.platform_secret.set_by': 'Set by',
    'change.field.platform_secret.withdrawn_at': 'Withdrawn on',
    'change.field.platform_secret.withdrawn_by': 'Withdrawn by',
    'change.field.platform_secret.last_test_ok': 'Last test passed',
    'change.field.report.github_issue_url': 'GitHub issue',
    'change.field.report.github_issued_at': 'Filed on GitHub on',
    'change.field.report.github_issued_by': 'Filed on GitHub by',
    'change.field.report.pm_task_ref': 'Project manager task',
    'change.field.report.pm_filed_at': 'Sent to the project manager on',
    'change.field.report.pm_filed_by': 'Sent to the project manager by',
    'change.field.pm_policy.mode': 'Mode of sending to the project manager',
    'change.field.pm_policy.auto_since': 'Automatic since',
    'change.field.pm_policy.created_by': 'Created by',
};
export const PLATFORM_RECORD_AR = {
    'change.field.platform_user.email': 'البريد',
    'change.field.platform_user.name': 'الاسم',
    'change.field.platform_user.password_hash': 'كلمة المرور',
    'change.field.platform_user.must_change_password': 'يلزمه اختيار كلمة مرور جديدة',
    'change.field.platform_user.role': 'الدور في المنصة',
    'change.field.platform_user.status': 'الحالة',
    'change.field.platform_user.second_factor_sealed': 'تطبيق المصادقة',
    'change.field.platform_user.second_factor_confirmed_at': 'فُعّل التحقق بخطوتين في',
    'change.field.platform_user.second_factor_pending_sealed': 'تطبيق مصادقة ينتظر أول رمز',
    'change.field.platform_user.recovery_code_hashes': 'رموز الاسترداد',
    'change.field.platform_user.locked_until': 'مقفل حتى',
    'change.field.platform_user.created_by': 'أضافه',
    'change.field.platform_user.withdrawn_at': 'سُحب وصوله في',
    'change.field.platform_user.withdrawn_by': 'سحب وصوله',
    'change.field.platform_secret.name': 'الإعداد',
    'change.field.platform_secret.sealed_value': 'القيمة',
    'change.field.platform_secret.last4': 'آخر أربعة أحرف',
    'change.field.platform_secret.fingerprint': 'البصمة',
    'change.field.platform_secret.set_by': 'ضبطه',
    'change.field.platform_secret.withdrawn_at': 'سُحب في',
    'change.field.platform_secret.withdrawn_by': 'سحبه',
    'change.field.platform_secret.last_test_ok': 'نجح آخر اختبار',
    'change.field.report.github_issue_url': 'قضية جيت هاب',
    'change.field.report.github_issued_at': 'فُتحت على جيت هاب في',
    'change.field.report.github_issued_by': 'فتحها على جيت هاب',
    'change.field.report.pm_task_ref': 'مهمة مدير المشاريع',
    'change.field.report.pm_filed_at': 'أُرسل إلى مدير المشاريع في',
    'change.field.report.pm_filed_by': 'أرسله إلى مدير المشاريع',
    'change.field.pm_policy.mode': 'وضع النقل إلى مدير المشاريع',
    'change.field.pm_policy.auto_since': 'التلقائي منذ',
    'change.field.pm_policy.created_by': 'أنشأه',
};
//# sourceMappingURL=i18n-platform-record.js.map